<app-header [label]="page_name"></app-header>
<div class="flex flex-wrap bg-white gap-4 items-center justify-end p-4">
    <div class="flex gap-2">
        <app-search-input *ngIf="list.selected_ids_count <= 0" #searchbar></app-search-input>
        <app-button color="bg-white text-primary border border-primary" icon="bx bx-arrow-to-bottom"></app-button>
    </div>
</div>
<app-ag-grid-list #list [list]="items" [colDefs]="columns" [itemName]="page_name" (fetch_new_list)="get_list($event)"></app-ag-grid-list>